import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

// Auth relies exclusively on httpOnly cookies set by the backend (`access_token` +
// `refresh_token`). We do NOT read/write tokens from localStorage to avoid XSS token theft.
export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  if ((config.method || "get").toLowerCase() === "get") {
    config.headers = {
      ...config.headers,
      "Cache-Control": "no-cache",
      Pragma: "no-cache",
    };
    config.params = {
      ...(config.params || {}),
      _fresh: Date.now(),
    };
  }

  return config;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function downloadFile(url, filename) {
  const a = document.createElement("a");
  // fetch with credentials includes the httpOnly cookie; no Bearer needed.
  fetch(`${API_BASE}${url}`, { credentials: "include" })
    .then((r) => r.blob())
    .then((blob) => {
      const objectUrl = URL.createObjectURL(blob);
      a.href = objectUrl;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
      setTimeout(() => URL.revokeObjectURL(objectUrl), 500);
    })
    .catch((err) => {
      console.error("File download failed:", err);
    });
}
